import { render, staticRenderFns } from "./label_group.vue?vue&type=template&id=d96c36ba&scoped=true&"
import script from "./label_group.vue?vue&type=script&lang=ts&"
export * from "./label_group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96c36ba",
  null
  
)

export default component.exports